/* ══════════════════════════════════════════════════════════════════════════
   The squish game (homepage band 00).

   - Counter shares localStorage["sq-squishes"] with the PDP squish test, so
     presses here count toward the RESTLESS5 unlock there. One restless meter
     across the whole store.
   - The cube is the WebGL liquid soft body (js/liquid.js), loaded lazily only
     when the band nears the viewport. Until it boots — or if WebGL/motion is
     unavailable — a flat illustrated keycap cube stands in, and the game works
     identically.
   - ?noliquid=1 forces the fallback (used by the test suite for determinism).
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var zone = document.getElementById('gameZone');
  if (!zone) return;
  var canvas = document.getElementById('liquidCanvas');
  var fb = document.getElementById('gameFallback');
  var countEl = document.querySelector('[data-game-count]');
  var certEl = document.querySelector('[data-game-cert]');

  var KEY = 'sq-squishes';
  var count = 0;
  try { count = parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) {}

  function render() {
    countEl.textContent = count;
    certEl.hidden = count < 10;
  }

  function bump() {
    count = Math.min(999, count + 1);
    try { localStorage.setItem(KEY, String(count)); } catch (e) {}
    render();
  }

  /* other tabs / the PDP move the same meter */
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    count = parseInt(e.newValue || '0', 10) || 0;
    render();
  });

  render();

  /* ─────────────────────  fallback keycap (always wired)  ──────────────── */
  fb.addEventListener('pointerdown', function () {
    bump();
    fb.classList.add('is-down');
    setTimeout(function () { fb.classList.remove('is-down'); }, 160);
  });

  /* ───────────────────────────  liquid boot  ───────────────────────────── */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var forced = /(^|[?&])noliquid=1/.test(location.search);
  if (reduce || forced || !('IntersectionObserver' in window)) return;

  var booted = false;
  var io = new IntersectionObserver(function (es) {
    if (!es[0].isIntersecting || booted) return;
    booted = true;
    io.disconnect();
    /* On Shopify, assets are flat and CDN-hashed: './liquid.js' resolves to a
       404 and the game silently stays on the flat fallback — which is exactly
       the kind of loss this port must not have. The bridge hands us the real
       URL. */
    import(window.SQ_DATA && window.SQ_DATA.assetBase
      ? window.SQ_DATA.assetBase + 'sq-liquid.js'
      : './liquid.js')
      .then(function (m) { return m.boot(canvas, zone); })
      .then(function (api) { if (api) wire(api); })
      .catch(function () { /* fallback simply stays */ });
  }, { rootMargin: '600px' });
  io.observe(zone);

  function wire(api) {
    zone.classList.add('is-live');

    var pressX = 0, pressY = 0;

    zone.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      pressX = e.clientX; pressY = e.clientY;
      api.press(e.clientX, e.clientY);
      bump();
      zone.setPointerCapture && zone.setPointerCapture(e.pointerId);
      e.preventDefault();
    });

    zone.addEventListener('pointermove', function (e) {
      api.move(e.clientX, e.clientY);
    });

    function up(e) {
      // dominant-axis tumble, from the press point relative to the zone centre
      // (verified in v1: top tips on X only, sides spin on Y, corners tumble
      // both, dead centre does a full 360)
      var r = zone.getBoundingClientRect();
      var dx = pressX - (r.left + r.width / 2);
      var dy = pressY - (r.top + r.height / 2);
      var reach = Math.min(r.width, r.height) / 2;
      var ax = Math.abs(dx), ay = Math.abs(dy);
      var dead = reach * 0.22, strong = reach * 0.82, DOM = 1.6;
      var kx = 0, ky = 0;
      if (ax < dead && ay < dead) ky = 360;
      else if (ax > ay * DOM) ky = (dx >= 0 ? 90 : -90) * (ax > strong ? 2 : 1);
      else if (ay > ax * DOM) kx = (dy >= 0 ? 90 : -90) * (ay > strong ? 2 : 1);
      else { ky = (dx >= 0 ? 90 : -90); kx = (dy >= 0 ? 90 : -90); }
      /* The tenth squish, and every tenth after, throws a bigger burst — the
         same milestone the PDP's squish test unlocks its code on. Everything
         else gets the ordinary release burst. */
      var milestone = count > 0 && count % 10 === 0;
      api.release(kx, ky, milestone ? 1 : 0.35);
      if (milestone) {
        setTimeout(function () { api.burst(0.85); }, 130);
        setTimeout(function () { api.burst(0.7); }, 260);
        zone.classList.add('is-cheer');
        setTimeout(function () { zone.classList.remove('is-cheer'); }, 900);
      }
    }

    zone.addEventListener('pointerup', up);
    zone.addEventListener('pointercancel', function () { api.release(0, 0); });
  }
})();
